<template>
    <div>
        <div class="col-12" @click.stop="">
            <div
                class="trip-results"
                style="height: 40em !important;"
            >
                <map-container
                    ref="mapContainer"
                    :menu-items="menuItems"
                    :find-user="false"
                    @onMapChanged="mapChanged"
                />
                <trip-map
                    v-if="map"
                    ref="tripMap"
                    :trip-results="trips"
                    :trip-item="mapItem"
                    :map="map"
                    :show-trip-info="false"
                    @setCurrentPoint="setCurrentPoint"
                    @carPositionSimulating="setCarPositionSimulating"
                />
            </div>
            <div class="map-trip-details-table pl-1 pt-1 pr-1">
                <vue3-datatable
                    v-if="tableItems.length > 0"
                    ref="resultTable"
                    :rows="tableItems"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="10em"
                    :sortable="true"
                    skin="bh-table-compact"
                    :row-class="getRowClass"
                    cell-class="routa-table-cell"
                    @row-click="showTripOnMap"
                >
                    <template #tripnote="row">
                        <span  v-for="tripNote in row.value.tripnotes" v-bind:key="tripNote.id">
                            <span class="tooltip-title">{{ toLocalTime(tripNote.start_time) }}-{{ toLocalTime(tripNote.end_time) }}</span>
                            {{ tripNote.note }}
                        </span>
                    </template>
                </vue3-datatable>
            </div>
            <div class="row nopads">
                <div class="col-12 d-flex justify-content-end">
                    <button
                        class="btn btn-success form-button mx-2 mt-2"
                        style="min-width: 7em"
                        :disabled="mapItem == null || this.withGeom === false"
                        @click="simulateTrip"
                    >
                        {{ $t('trip.simulate_trip') }}
                    </button>
                </div>
            </div>
        </div>

        <google-street-view-link
            v-if="streetViewDialogCoordinates"
            ref="streetView"
            :latLon="streetViewDialogCoordinates"
            :hide-text="true"
            @dialog-closed="streetViewDialogCoordinates = null"
        />

        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {orderMixin} from "@/components/mixins/OrderMixin";
import MapContainer from "../../map/MapContainer";
import TripMap from '../../trip/TripMap'
import {restApi} from "../../mixins/RestApiMixin";
import {timeUtils} from '../../mixins/TimeUtils'
import {vehicleHelper} from "../../mixins/VehicleMixin";
import {inject} from "vue";
import Vue3Datatable from '@bhplugin/vue3-datatable'
import GoogleStreetViewLink from "@/components/utils/GoogleStreetViewLink";


export default {
    name: "RoadReportTrips",
    components: {GoogleStreetViewLink, MapContainer, TripMap, Vue3Datatable},
    mixins: [orderMixin, restApi, timeUtils, vehicleHelper],
    props: {
        params: {default: null, required: true},
        geojson: {default: null}
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            streetViewDialogCoordinates: null,
            currentPoint: 0,
            currentTime: null,
            currentSpeed: 0,
            isCarSimulating: false,
            vehicle: null,
            map: null,
            order: null,
            withGeom: false,
            tableItems: [],
            trips: [],
            loading: 0,
            mapItem: null,
            selectMode: 'single',
            allTrips: true,
            fields: [
                {
                    field: "start_time",
                    title: this.$t('trip_list.start_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "end_time",
                    title: this.$t('trip_list.end_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'company',
                    title: this.$t('users.company'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'driver',
                    title: this.$t('trip_list.driver'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'vehicle',
                    title: this.$t('trip_list.vehicle'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "mode",
                    title: this.$t('trip_list.mode'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "duration",
                    title: this.$t('trip_list.duration') + ' (min)',
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "trip_length",
                    title: this.$t('trip_list.trip_length'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "tripnote",
                    title: this.$t('daily_summary.trip_notes'),
                    sort: false,
                    headerClass: 'routa-table-header'
                }
            ]
        }
    },
    watch: {
        params() {
            if (this.map) {
                this.fetchTrips()
            }
        },
        geojson() {
            if (this.geojson) {
                this.addGeoJsonMapObjects()
            } else {
                this.hideImportedObjects()
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.map = this.$refs.mapContainer.getMap()
            this.fetchTrips()
            this.addGeoJsonMapObjects()
        })
    },
    computed: {
        menuItems() {
            return [
                {
                    text: "Google Street View",
                    onClick: this.showStreetView
                }
            ]
        }
    },
    methods: {
        getRowClass(row) {
            return this.mapItem && row.id === this.mapItem.id ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.trips.length) {
                this.selectedRowId = this.trips[index].id
            }
        },

        initTableItems: function () {
            this.tableItems = []
            const temp = []
            if (this.trips.length > 0) {
                this.trips.forEach(function (item) {
                    temp.push({
                        start_time: this.toLocalTime(item.start_time),
                        end_time: this.toLocalTime(item.end_time),
                        company: item.company_name || '-',
                        driver: item.driver,
                        vehicle: item.vehicle,
                        duration: this.getDurationInMinutes(item.start_time, item.end_time),
                        mode:  this.getTripModeString(item.mode),
                        trip_length: item.length.toFixed(2),
                        road_coverage: item.road_coverage ? (item.road_coverage/1000).toFixed(2) : '-',
                        id: item.id,
                        delivery: item.delivery_amount ? item.delivery_amount + ' ' + item.delivery_unit : '-',
                        tripnotes: item.tripnotes
                    })
                }, this)
                this.$nextTick(() => {
                    this.tableItems = temp
                })
            }
        },

        close: function () {
            this.$refs.tripMap.resetMap()
            this.$emit('close')
        },

        simulateTrip: function () {
            this.$refs.tripMap.showMovingCar()
        },

        setCurrentPoint: function (currentPoint) {
            this.currentPoint = currentPoint
            // Check if mapItem and relevant arrays are available
            if (this.mapItem && this.mapItem.timestamps && this.mapItem.timestamps.length > 0 && this.mapItem.geometry && this.mapItem.geometry.length > 0) {
                // Get current timestamp and geometry
                let currentTime = this.mapItem.timestamps[this.currentPoint];
                this.currentTime = currentTime.substring(11, 16)
                let currentGeometry = this.mapItem.geometry[this.currentPoint];

                // Check if there are consecutive points available
                if (this.currentPoint < this.mapItem.timestamps.length - 1) {
                    // Get next timestamp and geometry
                    let nextTime = this.mapItem.timestamps[this.currentPoint + 1];
                    let nextGeometry = this.mapItem.geometry[this.currentPoint + 1];

                    // Calculate speed between current and next points
                    let speed = this.calculateSpeed(
                        currentGeometry.x, currentGeometry.y,
                        nextGeometry.x, nextGeometry.y,
                        currentTime, nextTime
                    );
                    if(speed !== Infinity) {
                        this.currentSpeed = speed.toFixed(2)
                    }
                }
            }
        },

        setCarPositionSimulating(isCarPositionSimulating) {
            this.isCarSimulating = isCarPositionSimulating
        },

        fetchTrips: function () {
            this.trips = []
            this.mapItem = null
            if (this.isCarSimulating) {
                this.$refs.tripMap.hideSimulation()
            }
            if (this.params && this.params.to && this.params.from && this.params.contractId && this.params.orderId && this.params.roadNum && this.params.secNum) {
                let params = {}
                params.contract = this.params.contractId
                params.order = this.params.orderId
                params.road_num = this.params.roadNum
                params.road_sec_from = this.params.secNum
                params.road_sec_to = this.params.secNum
                params.with_geom = 1
                params.trip_notes = 1
                params.from = this.params.from
                params.to = this.params.to
                params.timestamps = 1
                params.speed = 1
                this.loading++
                this.restFetchParams(this.tripUrl, params, this.handleResponseTrips, this.handleError)
            }
        },

        handleResponseTrips: function (response) {
            this.loading--
            this.trips = response.data
            this.initTableItems()
        },

        handleError: function () {
            this.loading--
            this.showAlert(this.$t('trip_list.err_general'))
        },

        showTripOnMap: function (item) {
            if (!item) {
                this.mapItem = null;
                this.$refs.tripMap.resetMap()
                this.showAllTrips()
            } else if (!this.mapItem || this.mapItem.id != item.id) {
                this.allTrips = false
                this.mapItem = null
                if (this.$refs.tripMap) {
                    this.$refs.tripMap.resetMap()
                }
                let trip = this.trips.find(trip => trip.id === item.id)
                if (trip.geometry.length > 1) {
                    this.withGeom = true
                    this.mapItem = trip
                } else {
                    this.withGeom = false
                }
            }
        },

        mapChanged(map) {
            this.map = map
            if (this.map) {
                if (this.params) {
                    this.fetchTrips()
                }
                this.addGeoJsonMapObjects()
            }
        },

        showStreetView(coord) {
            if (coord) {
                this.streetViewDialogCoordinates = {lat: coord.lat, lon: coord.lng}
                this.$nextTick(() => this.$refs.streetView.showPrompt())
            }
        },

        addGeoJsonMapObjects() {
            if (this.geojson && this.map) {
                this.geojson.forEach(road => {
                    this.map.addGeoJsonObjects(JSON.stringify(road), false, '#bf82da', false, 1, 10)
                })
            }
        },

        hideImportedObjects: function () {
            if (this.map) {
                this.map.hideGeoJsonObjects()
            }
        },

    }
}
</script>
<style>

.map-trip-details-table {
    white-space: nowrap;
    background: rgba(255, 255, 255, 0.7);
    overflow: hidden;
    max-height: 10em;
}



</style>
